import { IconType } from '@aibees/shared/components';
import { SxStyle } from '@aibees/shared/theme';
import { BadgeProps, keyframes } from '@mui/material';
import { NotificationMetadataStatus, NotificationType } from './types';

const rotateAnimation = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}`;

export const notificationIconMap: Partial<Record<NotificationType, IconType>> =
  {
    Profile: 'user-circle',
    UserManagement: 'black-people-group',
    TableLayoutModifier: 'view-week-outline',
    Download: 'file-download-outline',
    CSVTemplate: 'file-csv-outline',
  };

export const notificationBadgeInfoMap: Record<
  NotificationMetadataStatus,
  { icon: IconType; color: BadgeProps['color']; iconSx?: SxStyle }
> = {
  SUCCESS: { icon: 'check', color: 'success' },
  PROCESSING: {
    color: 'primary',
    icon: 'baseline-autorenew',
    iconSx: { animation: `${rotateAnimation} 1s linear infinite` },
  },
  FAILED: { icon: 'info-filled-bitcoin', color: 'error' },
};
